import { useEffect, useState } from "react";
import { Copy, HardHat } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Panel, SectionLabel } from "@/components/common/ui-kit";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export const TechFormPanel = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/tech-form").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const url = `${window.location.origin}${d.path}`;
  const code = `<iframe src="${url}" title="Resoconto attività tecnico" style="width:100%;height:980px;border:0" loading="lazy"></iframe>`;
  const copy = () => navigator.clipboard.writeText(code).then(() => toast.success("Codice copiato")).catch(() => toast.error("Copia non riuscita: seleziona il testo e copialo a mano."));
  return (
    <Panel className="p-5 lg:col-span-3" data-testid="techform-panel">
      <div className="mb-2 flex items-center gap-2"><HardHat className="h-4 w-4 text-slate-400" /><SectionLabel>Modulo resoconto per tecnici esterni</SectionLabel></div>
      <p className="mb-3 text-xs text-slate-500">Incolla questo codice in una pagina del sito per i tecnici esterni: compilano senza accedere a ON! Suite. Ogni resoconto arriva in «Moduli tecnici» da confermare, con i clienti suggeriti; confermato diventa un'attività svolta sull'intervento. Ricevuti: {d.total} · da confermare: {d.pending}.</p>
      <Textarea readOnly rows={3} value={code} className="font-mono text-xs" data-testid="techform-embed-code" />
      <div className="mt-3 flex flex-wrap gap-2">
        <Button onClick={copy} data-testid="techform-copy"><Copy className="mr-2 h-4 w-4" />Copia codice</Button>
        <Button variant="outline" asChild><a href={url} target="_blank" rel="noreferrer" data-testid="techform-preview">Apri anteprima</a></Button>
      </div>
    </Panel>
  );
};
